import React, { useEffect, useState } from "react";
import Header from "@/components/Header";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { api } from "@/lib/api";

export default function Admin() {
  const [users, setUsers] = useState([]);
  const [teams, setTeams] = useState([]);
  const [err, setErr] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const [u, t] = await Promise.all([api.get("/admin/users"), api.get("/admin/teams")]);
        setUsers(u.data.users || []);
        setTeams(t.data.teams || []);
      } catch (e) {
        setErr(e?.response?.data?.detail || e.message);
      }
    })();
  }, []);

  return (
    <div className="App min-h-screen">
      <Header />
      <div className="max-w-[1600px] mx-auto px-4 md:px-8 py-8 space-y-6" data-testid="admin-page">
        <h1 className="text-2xl font-bold tracking-tight text-[#003366]">Admin</h1>
        {err && <div className="text-sm text-red-700 font-mono">{err}</div>}
        <div className="grid md:grid-cols-2 gap-6">
          <Card className="grc-card border-slate-200 shadow-sm">
            <CardHeader><CardTitle className="text-sm text-slate-600">Users</CardTitle></CardHeader>
            <CardContent>
              {users.map((u) => (
                <div key={u.id} className="text-sm py-1 border-b border-slate-100 last:border-b-0 flex justify-between">
                  <span className="text-[#003366]">{u.username}</span>
                  <span className="font-mono text-xs text-[#008080] uppercase">{u.role}</span>
                </div>
              ))}
              {users.length === 0 && !err && <div className="text-sm text-slate-500">No users yet.</div>}
            </CardContent>
          </Card>
          <Card className="grc-card border-slate-200 shadow-sm">
            <CardHeader><CardTitle className="text-sm text-slate-600">Teams (RACI)</CardTitle></CardHeader>
            <CardContent>
              {teams.map((t) => (
                <div key={t.team_id} className="text-sm py-1 border-b border-slate-100 last:border-b-0 flex justify-between">
                  <span className="text-[#003366]">{t.name}</span>
                  <span className="font-mono text-xs text-slate-500">{t.department_head}</span>
                </div>
              ))}
            </CardContent>
          </Card>
        </div>
      </div>
    </div>
  );
}
